import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as servicesTodoList from 'services/todoList';

const getTodoListQueryKey = () => {
  //* default params
  const params = {
    pageIndex: 1,
    pageSize: 10,
    sort: [
      {
        fieldName: 'created',
        isAscending: false,
      },
    ],
    filters: [
      {
        fieldName: 'Status',
        filterType: 'In',
        values: ['Waiting', 'Accepted'],
      },
    ],
  };

  return ['workflow', 'get-todo-list', params];
};

export const useTodoListQuery = (props) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: getTodoListQueryKey(),
    queryFn: async ({ queryKey }) => {
      const params = queryKey[2];
      const response = await servicesTodoList.getTodoList(params);

      return response?.data;
    },
    ...props,
  });

  const invalidateTodoList = () => {
    queryClient.invalidateQueries({
      queryKey: getTodoListQueryKey(),
    });
  };
  return { ...query, invalidateTodoList };
};
